import styled from 'styled-components';
import { FlagGe } from '../assets';
import ErrorMessage from '../error-message/ErrorMessage';
export const CustomErroMessage = styled(ErrorMessage) `
  position: absolute;
  top: calc(100% + 0.8rem);
`;
export const PhoneInputContainer = styled.div `
  position: relative;
`;
export const PhoneIndexDiv = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1.4rem;
  height: 6.2rem;
  min-width: 10.4rem;
  max-width: 10.4rem;
  line-height: 1.7rem;
  margin-right: 1.2rem;
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  color: ${({ theme }) => theme.colors.borders.default};
  font-family: ${({ theme }) => theme.fonts.primary};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border: 1px solid
    ${({ theme, hasError }) => !hasError ? theme.colors.borders.default : theme.colors.borders.critical};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;
export const FlagImg = styled(FlagGe) `
  width: 3rem;
  height: 3rem;
  margin-right: 0.6rem;
`;
export const BorderBox = styled.div `
  display: flex;
  align-items: center;
`;
export const FlexBox = styled.div `
  display: flex;
  align-items: end;
  border-radius: ${({ theme }) => theme.borderRadius.low};
`;
//# sourceMappingURL=style.js.map